// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
	// <div class="gfm-embed" data-url="https://www.gofundme.com/f/song-writing-and-performance-tools/widget/medium/"></div><script defer src="https://www.gofundme.com/static/js/embed.js"></script>Write your JavaScript here

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});